// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1735628818559
      var cssReload = require("/Users/pht/workspace/okshop/okshop-diner/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  